<template>
  <div>
    <v-toolbar class="pl-nav-content white" flat light app fixed>
      <v-toolbar-title>Ranges</v-toolbar-title>
      <v-spacer></v-spacer>
      <range-form/>
    </v-toolbar>
    <filter-nav/>
    <range-list/>
  </div>
</template>

<script>
import FilterNav from '@/components/Filter/FilterNav'
import RangeList from '@/components/Range/RangeList'
import RangeForm from '@/components/Range/RangeForm'

export default {
  name: 'RangesIndex',

  components: {
    FilterNav,
    RangeList,
    RangeForm
  }
}
</script>
